import React from 'react';
import { Control, RegisterOptions, useController, useFormContext } from 'react-hook-form';
import Autocomplete, { AutocompleteOption, AutocompleteProps } from '../Autocomplete';

interface AutocompleteFieldProps extends Omit<
  AutocompleteProps,
  'initialValue' | 'invalid' | 'errors'
> {
  validation?: Omit<RegisterOptions, 'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'>;
  err?: object;
  isRequired?: boolean;
  control?: Control<any>;
  nameInput?: string;
}

const AutocompleteField: React.FC<AutocompleteFieldProps> = ({
  validation = {},
  isRequired = false,
  control,
  onChange,
  nameInput,
  errorContainerStyles,
  ...inputProps
}) => {
  const {
    formState: { errors },
    setValue,
  } = useFormContext();

  const {
    fieldState: { invalid },
    field: { onChange: onChangeForm, value, onBlur },
  } = useController({
    name: inputProps.name,
    control,
    rules: {
      required: isRequired && 'Required',
      ...validation,
    },
  });

  const handleChange = (data: AutocompleteOption | null) => {
    onChangeForm(data);
    onChange?.(data);
  };

  const onInputChange = (inputValue: string) => {
    if (nameInput) {
      setValue(nameInput, inputValue, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
    }
  };

  return (
    <Autocomplete
      errors={errors}
      initialValue={value}
      invalid={invalid}
      onBlur={onBlur}
      onChange={handleChange}
      onInputChange={onInputChange}
      errorContainerStyles={errorContainerStyles}
      {...inputProps}
    />
  );
};

export type { AutocompleteFieldProps };
export default AutocompleteField;
